<ion-header>
  <app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content class="ion-no-padding">
  <ion-item lines="none" class="header blue-item">
    <ion-label>
      <h1 class="h1-blue-page" *ngIf="!parentProfile"> {{ 'ACCOUNT.PROFILE_SELECTOR.EDIT_HEADER' | translate }}</h1>
      <h1 class="h1-blue-page" *ngIf="parentProfile"> {{'ACCOUNT.PROFILE_SELECTOR.HEADER_LOGGED_PARENT' | translate }} </h1>
    </ion-label>
  </ion-item>
  <div class="wrapper">
    <div class="avatars-wrapper clear">
      <ng-container *ngFor="let profile of profiles">
        <div class="profile-avatar" *ngIf="profile.profile_type !== 'Parent'">
          <img (click)="editProfile(profile)" [ngClass] = "{'black-white': !profile.access}" *ngIf="!profile.profile_avatar_path && profile.profile_type !== 'Parent'" src="{{this.getDefaultAvatar(profile)}}"/>
          <img (click)="editProfile(profile)" [ngClass] = "{'black-white': !profile.access}" *ngIf="profile.profile_avatar_path && profile.profile_type !== 'Parent'" src="{{profile.profile_avatar_path}}"/>
          <div class="profile-name" *ngIf="!profile.profile_nickName && profile.profile_type !== 'Parent'">{{profile.profile_firstName}}</div>
          <div class="profile-name" *ngIf="profile.profile_nickName && profile.profile_type !== 'Parent'">{{profile.profile_nickName}}</div>
          <div class="error" *ngIf = "!profile.access">{{'ERROR.PROFILE_SELECTOR.INVALID_PROFILE' | translate}}</div>
          <div class="edit" (click)="editProfile(profile)">{{'ACCOUNT.PROFILE_SELECTOR.MODIFY' | translate}}</div>
          <!-- <div class="edit" *ngIf= "(parentProfile || teacherProfile) && !noEdit && profile.profile_type != 'Parent' && themeClass === 'playbacpresse' && profile.profile_subscriber_number" (click)="openAboSpace(profile)">{{'ACCOUNT.PROFILE_SELECTOR.ABO_SPACE' | translate}}</div> -->
        </div>
      </ng-container>
      <div class="profile-avatar add" [hidden] = "this.isHidden" *ngIf= "proflen <= 5" (click)="addNewProfile()">
        <img class="add-profile-icon" src="/../assets/img/add-profile.png"/>
        <div class="profile-name">{{'ACCOUNT.PROFILE_SELECTOR.ADD_PROFILE' | translate}}</div>
      </div>
      <div *ngIf="error && error === 'ip'" class="error">{{ 'ERROR.PROFILE_SELECTOR.EXCEEDED_IPS' | translate }}</div>
    </div>
  </div>
  <div class="coupon-wrapper" *ngIf="profiles && parentProfile">
    <div class="coupon-cta-text">{{'ACCOUNT.PROFILE_SELECTOR.COUPON_CTA' | translate}}</div>
    <ion-button class="coupon-code" (click)="goToAddCupons()">{{ 'ACCOUNT.PROFILE_SELECTOR.COUPON_TEXT' | translate }}</ion-button>
  </div>
  <ion-item lines="none" class="compte blue-item" *ngIf="this.validProfiles && (!noEdit && this.validProfiles.length > 0)" (click)="goBackToChooseProfile()">
  <!-- <img *ngIf="this.getAvatar() == ''" src="{{this.getDefaultLoggedAvatar()}}" class="sophie"> -->
  <!-- <img *ngIf="this.getAvatar() != ''" src="{{this.getAvatar()}}" class="sophie"> -->
    <ion-label>{{ 'ACCOUNT.PROFILE_SELECTOR.BACK-TO-SELECT-PROFILE' | translate }}</ion-label>
  </ion-item>
  <ion-item lines="none" class="logout blue-item" (click) = "logOut()">
    <ion-label>{{ 'ACCOUNT.PROFILE_SELECTOR.DISCONNECT' | translate }}</ion-label>
  </ion-item>
</ion-content>
<ion-footer> <app-bottom-menu></app-bottom-menu> </ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popUpData" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
